// @flow
class ArrayUtil {
    static insertItemAtIndex({ array, index, item }) {
        const ret = array.slice(0);
        ret[index] = item;
        return ret;
    }

    static getArrayOfLength(length: number) {
        if (length < 0) {
            return [];
        }

        return [...Array(length).keys()];
    }
    static removeItemAtIndex({ array, index }) {
        return [...array.slice(0, index), ...array.slice(index + 1)];
    }

    static SORT_DIR = {
        ASC: 'ASC',
        DESC: 'DESC'
    };

    static sortByKey(list, sortBy, direction = ArrayUtil.SORT_DIR.ASC) {
        const result = {
            POSITIVE: 1,
            NEGATIVE: -1,
            WHOLE: 0
        };

        return list.sort((firstItem, secondItem) => {
            let primaryItem = firstItem[sortBy];
            let secondaryItem = secondItem[sortBy];
            if (
                typeof primaryItem === 'string' &&
                typeof secondaryItem === 'string'
            ) {
                primaryItem = firstItem[sortBy].toLowerCase();
                secondaryItem = secondItem[sortBy].toLowerCase();
            }
            if (primaryItem > secondaryItem) {
                return direction === ArrayUtil.SORT_DIR.ASC
                    ? result.POSITIVE
                    : result.NEGATIVE;
            }
            if (primaryItem < secondaryItem) {
                return direction === ArrayUtil.SORT_DIR.ASC
                    ? result.NEGATIVE
                    : result.POSITIVE;
            }
            if (primaryItem === secondaryItem) {
                return result.WHOLE;
            }

            return;
        });
    }

    // This functions takes an array of objects and a key of the objects and returns a new array
    // of objects with the object[key] value being unique
    static getArrayOfUniqueObjectsByKey(arrayOfObjects, objectKey) {
        // Get a 2d of array of type [ [objectKeyValue, arrayObject] ] for Map creation
        const arrayCloneWithKeyValues = arrayOfObjects.map(item => [
            item[objectKey],
            item
        ]);
        // Map filters out duplicate keys, so objects with duplicate objectKeyValue will be dropped
        const uniqueObjectsMap = new Map(arrayCloneWithKeyValues).values();
        const uniqueObjectsArray = [...uniqueObjectsMap];
        return uniqueObjectsArray;
    }
}

export default ArrayUtil;
